/**
 * Contextual Quick Replies Generator
 * Generates context-aware quick reply suggestions based on current page
 */

export interface IQuickReply {
  key: string;
  label: string;
  // Optional full command text sent to the chat agent when clicked.
  // When omitted, `label` is sent as the message content.
  message?: string;
}

export interface IContextualReplies {
  [section: string]: {
    en: IQuickReply[];
    vi: IQuickReply[];
  };
}

const CONTEXTUAL_REPLIES: IContextualReplies = {
  home: {
    en: [
      { key: 'help', label: 'What can you help me with?' },
      {
        key: 'checkin8h',
        label: 'Working 8AM - 5PM',
        message:
          'Register a leave early request of 30 minutes for today, reason: Working from 8AM to 5PM'
      },
      { key: 'leaveBalance', label: 'Check my leave balance' },
      { key: 'remotePolicy', label: 'Company remote work policy' },
      { key: 'officeRules', label: 'Office etiquette rules' },
      { key: 'meetingRooms', label: 'Meeting room usage rules' }
    ],
    vi: [
      { key: 'help', label: 'Bạn có thể giúp gì cho tôi?' },
      {
        key: 'checkin8h',
        label: 'Làm việc 8h - 17h',
        message: 'Đăng ký về sớm 30 phút cho hôm nay, lý do: Làm việc từ 8h đến 17h'
      },
      { key: 'leaveBalance', label: 'Kiểm tra số ngày phép' },
      { key: 'remotePolicy', label: 'Chính sách remote của công ty' },
      { key: 'officeRules', label: 'Quy tắc sinh hoạt tại văn phòng' },
      { key: 'meetingRooms', label: 'Quy tắc sử dụng phòng họp' }
    ]
  },
  knowledge_base: {
    en: [
      { key: 'remotePolicy', label: 'Company remote work policy' },
      { key: 'officeRules', label: 'Office etiquette rules' },
      { key: 'meetingRooms', label: 'Meeting room usage rules' }
    ],
    vi: [
      { key: 'remotePolicy', label: 'Chính sách remote của công ty' },
      { key: 'officeRules', label: 'Quy tắc sinh hoạt tại văn phòng' },
      { key: 'meetingRooms', label: 'Quy tắc sử dụng phòng họp' }
    ]
  }
};

/**
 * Get contextual quick replies for current section
 */
export const getContextualReplies = (section: string, language = 'vi'): IQuickReply[] => {
  const lang = language === 'en' ? 'en' : 'vi';
  const sectionReplies = CONTEXTUAL_REPLIES[section];

  if (sectionReplies) {
    return sectionReplies[lang] || sectionReplies.vi;
  }

  // Default replies for unknown sections - use home replies
  return CONTEXTUAL_REPLIES.home[lang] || CONTEXTUAL_REPLIES.home.vi;
};
